import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  enh_action: 'add',
  event_name: 'add_to_bag',
  event_category: 'ecommerce',
  event_action: 'add to bag',
  event_label: null, // '<product name> - <product ID>'
  product_id: null, // '<product id>'
  product_shade: null, // '<product shade>'
  product_size: null, // '<product size>'
  product_sku: null // '<sku id>'
};

function trackAddToCart(_: string, eventData: IDataLayer = {}) {
  if (eventData.is_pincer_cart) {
    // TODO: investigate why this is being pulled from the data layer before the event is fired
    // why isn't this being passed in the actual event, then added to the datalayer?
    const data = tealium.dataLayer?.data || {};

    if (eventData.product_sku?.length) {
      const sku_index = data.cart_product_sku?.indexOf(eventData.product_sku[0]);
      if (sku_index >= 0) {
        eventData.event_label = tealium.dataLayer.formatProductEventLabel({
          product_name: [data.cart_product_name[sku_index]],
          product_id: [data.cart_product_id[sku_index]]
        });
        eventData.product_id = [data.cart_product_id[sku_index]];
        eventData.product_is_replenishment_item = [
          data.cart_product_is_replenishment_item[sku_index]
        ];
        eventData.product_price = [data.cart_product_price[sku_index]];
        eventData.product_product_code = [data.cart_product_product_code[sku_index]];
        eventData.product_replenishment_frequency = [
          data.cart_product_replenishment_frequency[sku_index]
        ];
        eventData.product_shade = [data.cart_product_shade[sku_index]];
        eventData.product_size = [data.cart_product_size[sku_index]];
        eventData.product_sku = [data.cart_product_sku[sku_index]];
      }
    }
  } else {
    eventData.event_label = tealium.dataLayer.formatProductEventLabel(eventData);
  }

  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('addToCart', trackAddToCart);
